import { Activity } from "./activity";
import { Location, LocationCoordinates } from './location';

export enum UserRole {
    USER = 'USER',
    CREATOR = 'CREATOR',
    ADMIN = 'ADMIN',
}

export interface User {
    id: string;
    name: string;
    email: string;
    bio: string;
    role: UserRole;
    
    // legacy location field
    location?: string;

    // new location field
    locationId?: string;
    locationData?: Location;

    sessionToken: string;
    avatar?: string;
    createdAt?: string;
    updatedAt?: string;
    participations?: Array<Activity>;
}

// helper interface for location handling
export interface LocationDisplayData {
    displayName: string;
    coordinates?: LocationCoordinates;
    fullLocation?: Location;
}

export interface ActivityWithLocation extends Activity {
    locationDisplay: LocationDisplayData;
}

export interface Creator {
    id: string
    email: string
    name: string
    type: string
    avatar?: string
    coverImage?: string
    isVerified: boolean
    website?: string
    phone?: string
    address?: string
    city: string
    state: string
    zip: string
    country: string
    description: string
    createdAt?: string
    updatedAt?: string
}

export interface AuthResponse extends User {
    // sessionToken: string;
    canJoinActivities: boolean;
    // canCreateActivities: boolean;
    // canManageActivities: boolean;
    // canViewAnalytics: boolean;
  }
